import { callApi } from "./api";
import { parseBoolean } from "./utils/transforms";
import { normalize, schema } from "normalizr";

const fontCategory = new schema.Entity("category");
const fontCategories = new schema.Array(fontCategory);
const fontSchema = new schema.Entity(
  "font",
  {
    categories: fontCategories,
  },
  {
    mergeStrategy: (entityA, entityB) => {
      let categories = [...entityA.categories];
      entityB.categories.forEach((category) => {
        if (entityA.categories.indexOf(category) === -1) {
          categories.push(category);
        }
      });
      return {
        ...entityA,
        ...entityB,
        categories: categories,
      };
    },
  },
);

function transformFontsResponse(response) {
  let fonts = [];
  response.forEach(function (data) {
    let font = {
      id: data.id,
      name: data.name,
      is_active: data.is_active,
      thumbnail: data.thumbnail,
      categories: [
        {
          id: data.category_id,
          name: data.category_name,
          weight: data.category_weight,
          character_type: data.category_character_type,
          is_default: parseBoolean(data.category_is_default),
          is_foil_and_embossed: parseBoolean(
            data.category_is_foil_and_embossed,
          ),
          is_stencil: parseBoolean(data.category_is_stencil),
        },
      ],
    };
    fonts.push(font);
  });
  return fonts;
}

export const fetchDefaultFonts = () => {
  return callApi("fonts?_format=json").then((response) => {
    if (response.response && response.response.length) {
      let data = transformFontsResponse(response.response);
      let normalizedData = normalize(data, [fontSchema]);
      Object.values(normalizedData.entities.category).forEach((category) => {
        let fonts = Object.values(normalizedData.entities.font)
          .filter((font) => font.categories.indexOf(category.id) !== -1)
          .map((font) => font.id);
        category.fonts = fonts;
      });

      return { response: normalizedData };
    } else {
      return { response: {} };
    }
  });
};
